import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE_URL = 'https://newalemny.3almny.app/api';

// 1. بدء الامتحان (POST)
export const startExamSession = createAsyncThunk(
  'examSession/startExamSession',
  async (examId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token3almny');
      const response = await fetch(`${BASE_URL}/tests/student_enter_test/${examId}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || 'فشل بدء الامتحان');
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'فشل بدء الامتحان');
    }
  }
);

// 2. جلب تفاصيل الامتحان (GET)
export const fetchExamDetails = createAsyncThunk(
  'examSession/fetchExamDetails',
  async (examId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token3almny');
      const response = await fetch(`${BASE_URL}/tests/student_test_details/${examId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || 'فشل جلب تفاصيل الامتحان');
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'فشل جلب تفاصيل الامتحان');
    }
  }
);

// 3. إرسال الإجابات (POST)
export const submitExamAnswers = createAsyncThunk(
  'examSession/submitExamAnswers',
  async ({ examId, answers }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token3almny');
      const response = await fetch(`${BASE_URL}/tests/submit_test/${examId}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ answers }),
      });
      const data = await response.json();
      if (!response.ok) {
        return rejectWithValue(data.message || 'فشل إرسال الإجابات');
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'فشل إرسال الإجابات');
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  examStarted: false,
  examDetails: null,
  submitResult: null,
};

const examSessionSlice = createSlice({
  name: 'examSession',
  initialState,
  reducers: {
    clearExamSession: (state) => {
      state.loading = false;
      state.error = null;
      state.examStarted = false;
      state.examDetails = null;
      state.submitResult = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // بدء الامتحان
      .addCase(startExamSession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(startExamSession.fulfilled, (state, action) => {
        state.loading = false;
        state.examStarted = !!action.payload.result;
      })
      .addCase(startExamSession.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // جلب تفاصيل الامتحان
      .addCase(fetchExamDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExamDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.examDetails = action.payload.result;
      })
      .addCase(fetchExamDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // إرسال الإجابات
      .addCase(submitExamAnswers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitExamAnswers.fulfilled, (state, action) => {
        state.loading = false;
        state.submitResult = action.payload.result;
      })
      .addCase(submitExamAnswers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearExamSession } = examSessionSlice.actions;
export default examSessionSlice.reducer;